import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import {
  CREATE_ACCOUNTS,
  DELETE_ACCOUNTS,
  GET_ACCOUNTS,
  GET_ACCOUNT_BY_ID,
  UPDATE_ACCOUNTS,
} from './actionType';

import { notifyError, notifySuccess } from '../../components/notify';
import {
  accountsCreate,
  accountsDelete,
  accountsEdit,
  accountsGet,
  accountsGetById,
} from '../../helpers/backend_helper';
import { AccountsApiResponseError, AccountsApiSuccess } from './action';

function* getAccounts() {
  try {
    const response = yield call(accountsGet);
    yield put(AccountsApiSuccess(GET_ACCOUNTS, response));
  } catch (error) {
    yield put(AccountsApiResponseError(GET_ACCOUNTS, error));
  }
}

function* getAccountById({ payload }) {
  const { id } = payload;

  try {
    const response = yield call(accountsGetById, id);
    yield put(AccountsApiSuccess(GET_ACCOUNT_BY_ID, response));
  } catch (error) {
    yield put(AccountsApiResponseError(GET_ACCOUNT_BY_ID, error));
  }
}

function* createAccounts({ payload }) {
  const { data, history } = payload;
  try {
    const response = yield call(accountsCreate, data);

    yield put(AccountsApiSuccess(CREATE_ACCOUNTS, response));

    notifySuccess('Conta criada com sucesso!');
    history.goBack();
  } catch (error) {
    yield put(AccountsApiResponseError(CREATE_ACCOUNTS, error));
    notifyError('Erro ao criar a conta!');
  }
}

function* updateAccounts(data) {
  const { history } = data.payload;

  try {
    const response = yield call(accountsEdit, data.payload);

    yield put(AccountsApiSuccess(UPDATE_ACCOUNTS, response));

    notifySuccess('Conta editada com sucesso!');
    history.goBack();
  } catch (error) {
    yield put(AccountsApiResponseError(UPDATE_ACCOUNTS, error));
    notifyError('Erro ao editar a conta!');
  }
}

function* deleteAccounts({ payload }) {
  const { id } = payload;
  try {
    const response = yield call(accountsDelete, id);

    yield put(AccountsApiSuccess(DELETE_ACCOUNTS, response));

    notifySuccess('Conta deletada com sucesso!');
  } catch (error) {
    yield put(AccountsApiResponseError(DELETE_ACCOUNTS, error));
    notifyError('Erro ao deletar a conta!');
  }
}

export function* watchGetAccounts() {
  yield takeEvery(GET_ACCOUNTS, getAccounts);
}

export function* watchGetAccountById() {
  yield takeEvery(GET_ACCOUNT_BY_ID, getAccountById);
}

export function* watchCreateAccounts() {
  yield takeEvery(CREATE_ACCOUNTS, createAccounts);
}
export function* watchUpdateAccounts() {
  yield takeEvery(UPDATE_ACCOUNTS, updateAccounts);
}

export function* watchDeleteAccounts() {
  yield takeEvery(DELETE_ACCOUNTS, deleteAccounts);
}

function* AccountsSaga() {
  yield all([fork(watchGetAccounts)]);
  yield all([fork(watchGetAccountById)]);
  yield all([fork(watchCreateAccounts)]);
  yield all([fork(watchUpdateAccounts)]);
  yield all([fork(watchDeleteAccounts)]);
}

export default AccountsSaga;
